<template>
	<div class="tw-w-full tw-bg-white tw-py-10 tw-px-4 tw-bg-bgMain">

		<div class="tab-view-container tw-w-full tw-flex tw-flex-col " :class="{ 'animate-slide-up': isVisible }">
			<span class="tw-w-full tw-text-center tw-text-xl tw-font-bold tw-text-textMain tw-mb-4 "
				v-html="$t('首页解决方案标题')"></span>
			<span class="tw-w-full tw-text-center tw-text-sm  tw-text-textDisabled tw-mb-6 ">{{ $t("覆盖多领域需求，整合技术与服务驱动业务高效落地与持续增长") }}
			</span>


			<div class="tw-grid tw-grid-cols-2 tw-gap-4">
				<div class="scheme-card" v-for="(item, index) in tabsList" :key="index">
					<img class="scheme-card-bg" :src="item.mainImg" :alt="item.name">
					<div class="scheme-card-content">
						<h3 class="scheme-card-title">{{ item.name }}</h3>
						<p class="scheme-card-intro">{{ item.intro }}</p>
						<span @click.stop="handleClickRoute(item)" class="scheme-card-btn">{{ $t("了解更多") }}</span>
					</div>
				</div>
			</div>



			<div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-5" style="font-size: 14px;
color: #999999;">
				{{ $t("找不到合适的解决方案？") }}
				<span style="color: #4077F8FF; cursor: pointer;" @click="handleClickRoute">
					<span>{{ $t("立即咨询") }}</span>
					<b-icon icon="chevron-right" class="tw-ml-1"></b-icon>
				</span>
			</div>

		</div>
	</div>
</template>

<script>
import { solutionsApi } from "@/api/modules/home";
import BigImg from "@/components/skeleton/bigImg.vue";
export default {
	name: 'mobileSchemeView',
	components: {
		BigImg
	},
	data() {
		return {
			tabsList: [],
			isLoading: true,
			isVisible: false,
			observer: null,

		};
	},
	mounted() {
		const info = JSON.parse(localStorage.getItem('indexInfo'));
		if (info) {
			this.getList();
		}
		this.$nextTick(() => {
			setTimeout(() => {
				this.initIntersectionObserver();
			}, 500);
		});
	},
	methods: {
		initIntersectionObserver() {

			this.observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting && !this.isVisible) {

						this.isVisible = true;
						// 动画只执行一次，所以可以断开观察器
						this.observer.disconnect();
					}
				});
			}, {
				threshold: 0, // 当组件10%可见时触发
			});

			this.observer.observe(this.$el);
		},
		getList() {
			solutionsApi({
				pageIndex: 1,
				pageSize: 5,
			}).then((res) => {
				this.tabsList = res.data.list || [];
			})
		},
		handleClickRoute(row) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			if (row.id) {
				localStorage.setItem("detailForm", JSON.stringify(row))
				this.$router.push({
					path: '/solution/' + row.id + "?isApi=false"
				});
			} else {
				this.$router.push({
					path: '/solution'
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">
.tab-view-container {
	opacity: 0;
	transform: translateY(50px);
	transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
	opacity: 1;
	transform: translateY(0);
}

.scheme-card {
	width: 100%;
	aspect-ratio: 1;
	background: linear-gradient(180deg, #2651ff 0%, #0d42f9cc 50%, rgba(0, 59, 254, 0) 100%);
	border-radius: 8px;
	position: relative;
	overflow: hidden;
}

.scheme-card-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0.3;
	z-index: 1;
}

.scheme-card-content {
	position: relative;
	z-index: 2;
	padding: 12px;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.scheme-card-title {
	font-weight: 600;
	font-size: 16px;
	color: #FFFFFF;
	line-height: 24px;
	margin: 0;
}

.scheme-card-intro {
	font-weight: 600;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.8);
	line-height: 16px;
	margin: 6px 0;
}

.scheme-card-btn {
	display: block;
	width: 100%;
	height: 40px;
	background: #FFFFFF;
	border-radius: 8px;
	border: 1px solid #4077F8;
	cursor: pointer;
	text-align: center;
	line-height: 40px;
	font-weight: 600;
	font-size: 14px;
	color: #4077F8;
	margin-top: auto;
}

.flex-1 {
	flex: 1;
}

.flex-start {
	display: flex;
	justify-content: flex-start;
}

.solution-container {
	display: flex;
}

.solution-item {
	display: flex;
	height: 400px;
	margin: 10px;
	border-radius: 10px;
	overflow: hidden;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	position: relative;
	border-radius: 0;

	&:hover {
		cursor: pointer;
		transform: translateY(-3px);
	}
}

.solution-item img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.solution-content {
	position: absolute;
	padding: 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	color: #fff;
	height: 100%;
}

.solution-title {
	font-size: 20px;
	margin-bottom: 10px;
}

.solution-desc {
	font-size: 14px;
	margin-bottom: 10px;
}

.solution-link {
	color: #007bff;
	text-decoration: none;
}

.consult-button {
	display: inline-block;
	padding: 6px 12px;
	background-color: rgba(255, 255, 255, 0.1);
	border: 1px solid #fff;
	color: white;
	text-decoration: none;
}

.check-btn {
	width: 172px;
	height: 43px;
	line-height: 43px;
	border-radius: 0px 0px 0px 0px;
	margin: 0 auto;
	border-radius: 5px;
	border: 1px solid #EBEBEB;
	cursor: pointer;

	&:hover {
		background: #007bff;
		color: white;
		border: 1px solid #007bff;
	}
}

.card-content {
	overflow: hidden;
	background: linear-gradient(rgba(196, 215, 255, 0.80), rgba(255, 255, 255, 1));
}
</style>
